import React, { useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ProjectsService from "../Services/ProjectsService";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";

interface ProjectPercentageBLModalProps {
  code: string;
  percentage: number | null;
  afterClose: Function;
}

const ProjectPercentageBLModal = (props: ProjectPercentageBLModalProps) => {
  const { instance } = useMsal();

  const projectsService = useMemo(
    () => new ProjectsService(instance),
    [instance]
  );

  const [percentage, setPercentage] = useState<number | null>(props.percentage);
  const [visible, setVisible] = useState<boolean>(true);

  const modalToggle = () => {
    setVisible((visible) => {
      return !visible;
    });

    props.afterClose();
  };

  async function save() {
    try {
      if (props.code !== null) {
        await projectsService.updateProjectPercentageBL(props.code, percentage);

        setVisible(false);

        props.afterClose();
      }
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  function handleSetPercentage(event: React.ChangeEvent<HTMLInputElement>) {
    let value = null;

    if (!Number.isNaN(parseFloat(event.target.value)))
      value = parseFloat(event.target.value);

    setPercentage(value);
  }

  return (
    <Modal isOpen={visible} toggle={modalToggle} className="mw-100 w-75">
      <ModalHeader toggle={modalToggle}>{props.code} - % BL</ModalHeader>
      <ModalBody>
        <form className="form-inline">
          <div className="form-group">
            <label
              className="my-1 mr-2"
              htmlFor="totalOrderedSuppliersPercentageInput"
            >
              % BL
            </label>
            <input
              type="text"
              className="form-control my-1 mr-sm-2"
              id="totalOrderedSuppliersPercentageInput"
              onChange={handleSetPercentage}
              value={percentage ?? ""}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={save}>
          Bewaren
        </Button>{" "}
        <Button color="secondary" onClick={modalToggle}>
          Sluiten
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProjectPercentageBLModal;
